import { Home, Briefcase, Network, TrendingUpDown, HandCoins, ClipboardCheck, Settings, LayoutDashboard, Target, Banknote } from "lucide-react";

const mainMenus = [
  {
    group : "",
    isActive : false,
    items : [
      {
        title : "Home",
        url : "/",
        icon : Home,
        subItems : [],
        // current : false
      },
      {
        title : "Workshop",
        // url : "/workshops",
        icon : Briefcase,
        // current : false,
        subItems : [
          {
            title : "Overview",
            url : "/workshops",
            icon : LayoutDashboard
          },
          {
            title : "Decision Tree",
            url : "/workshops/decision-tree",
            icon : Network,
            // current : false

          },
          {
            title : "Naive Bayes",
            url : "/workshops/naive-bayes",
            icon : TrendingUpDown,
            // current : false
          },
        ]
      },
    ]
  },
  {
    group : "Features",
    isActive : false,
    items : [
      {
        title : "Budget Planner",
        // url : "/features/budget-planner",
        icon : HandCoins,
        subItems: [
          {
            title : "Overview",
            url : "/features/budget-planner",
            icon : LayoutDashboard
          },
          {
            title : "Budgets",
            url : "/features/budget-planner",
            icon : Target
          },
          {
            title : "Cash Flows",
            url : "/features/budget-planner/cash-flows",
            icon : Banknote
          },
          {
            title : "Settings",
            url : "/features/budget-planner/settings",
            icon : Settings
          },
        ],
        // current : false
      },
      {
        title : "Task Manager",
        url : "#",
        icon : ClipboardCheck,
        subItems: [],
        // current : false
      },
    ]
  },
  {
    group : "Personalization",
    isActive : false,
    items : [
      {
        title : "Settings",
        url : "#",
        icon : Settings,
        subItems: [],
        // current : false
      }
    ]
  }
]

export default mainMenus;